module.exports = require("./NavBarContainer.vue");